import React from 'react'
import { FieldLayoutBox } from './FieldLayoutBox'
import { FieldValueParser, FieldValueFormatter } from './FieldValueConverters'

import { Field } from 'redux-form'
import { pt } from 'common-data/proptypehelpers'
import _ from 'common-tools/LodashHelper'
import TagsInput from 'react-tagsinput'

class TagsBoxClass extends React.Component {
  constructor () {
    super()
    this.state = { tag: '' }
  }

  static propTypes = {
    theme: pt.string
  }

  handleChangeInput (tag) {
    this.setState({ tag })
  }

  render () {
    const { theme, ...rest } = this.props
    const { tag } = this.state

    return (
      <FieldLayoutBox {...rest}>
        {({ showError, value, onChange, onBlur, name, onFocus, placeHolder, loading }) => <TagsInput
          value={value || []}
          onChange={onChange}
          inputValue={tag}
          onChangeInput={this.handleChangeInput}
          inputProps={{
            id: `tagsbox_${name}`,
            className: `react-tagsinput-input`,
            placeholder: _.isEmpty(value) ? placeHolder : ''
          }}
        />
        }
      </FieldLayoutBox>
    )
  }
}

export const TagsBox = ({ parse, format, fieldType, ...rest }) => { return <Field parse={fieldType ? FieldValueParser(fieldType) : parse} format={fieldType ? FieldValueFormatter(fieldType) : format} {...rest} component={TagsBoxClass} /> } // eslint-disable-line
export default TagsBox
